export const WEB_IDLE_MS = 30 * 60 * 1000;
export const WEB_RENEW_REMAINING_MS = 10 * 60 * 1000;
/** Mobile OS freezes JS in background, so renew while foreground with a 1-day buffer. */
export const MOBILE_RENEW_REMAINING_MS = 24 * 60 * 60 * 1000;
export const WEB_CHECK_MS = 45 * 1000;

let lastActivityMs = Date.now();
let transferCount = 0;

/**
 * Phone / tablet. Background timers do not work there, so login uses
 * client=mobile (7-day sliding token) and renews on resume.
 */
export function isMobileClient(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent || '';
  if (/Mobi|Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return true;
  }
  if (/iPad/i.test(ua)) {
    return true;
  }
  // iPadOS 13+ reports as Macintosh.
  if (navigator.maxTouchPoints > 1 && /Mac/i.test(ua)) {
    return true;
  }
  return false;
}

export function authClientKind(): 'web' | 'mobile' {
  return isMobileClient() ? 'mobile' : 'web';
}

export function isDocumentHidden(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden';
}

export function markSessionUsed(): void {
  lastActivityMs = Date.now();
}

export function beginTransfer(): void {
  transferCount += 1;
  markSessionUsed();
}

export function endTransfer(): void {
  transferCount = Math.max(0, transferCount - 1);
  markSessionUsed();
}

export function isMediaPlaying(): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  return Array.from(document.querySelectorAll('video, audio')).some(
    (el) => el instanceof HTMLMediaElement && !el.paused && !el.ended
  );
}

/** 仍算使用中：近 30 分有操作，或播放中，或上傳／下載進行中。 */
export function isSessionInUse(): boolean {
  return transferCount > 0 || isMediaPlaying() || Date.now() - lastActivityMs < WEB_IDLE_MS;
}

export function isIdleExpired(): boolean {
  return transferCount === 0 && !isMediaPlaying() && Date.now() - lastActivityMs >= WEB_IDLE_MS;
}
